import { DotWebComponentsError } from '@/errors/dot-web-components-error';

export const onAutoCaptureError = (error: Error) => {
  throw new DotWebComponentsError(error.message, error.name);
};
